import { pickupTrackingAction } from './pickupTrackingActionCreator';
const initalstate = {
  isLoading: false,
  isLoaded: false,
  pickupData: [],
  error: null
};

const pickupTrackingReducer = (state = initalstate, action) => {
  switch (action.type) {
    case pickupTrackingAction.GET_PICKUP_DATA: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default pickupTrackingReducer;
